/*
 * FRSN Analytics – Verhaltens-Tracking (Storefront DOM).
 *
 * Sendet ausschließlich `frsn_`-prefixte GA4-Custom-Events über window.frsnTrack
 * (in snippets/global-analytics.liquid definiert, consent-gated, send_page_view:false).
 * Kollidiert NICHT mit den Standard-E-Commerce-Events des Google-App-Web-Pixels.
 *
 * Erfasst: Klicks (CTA/Nav/Produktkarte/Social/Outbound), Scroll-Tiefe,
 * Verweildauer, Suche, Filter/Sortierung, Varianten, Add-to-Cart-Intent,
 * Drawer/Quickview/Cart, Video, Accordions, Newsletter.
 */
(function () {
  'use strict';

  function track(name, params) {
    if (typeof window.frsnTrack === 'function') {
      window.frsnTrack(name, params || {});
    }
  }

  var host = window.location.host;

  function text(el) {
    if (!el) { return ''; }
    var t = (el.getAttribute('aria-label') || el.textContent || '').trim();
    return t.replace(/\s+/g, ' ').slice(0, 120);
  }

  function handleFromUrl(url, kind) {
    try {
      var u = new URL(url, window.location.origin);
      var m = u.pathname.match(new RegExp('/' + kind + '/([^/?#]+)'));
      return m ? m[1] : '';
    } catch (e) { return ''; }
  }

  // ---- Klick-Delegation (Links + Buttons) -------------------------------
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (link) {
      var href = link.getAttribute('href') || '';
      var abs;
      try { abs = new URL(href, window.location.origin); } catch (err) { abs = null; }

      // Outbound
      if (abs && abs.host && abs.host !== host && abs.protocol.indexOf('http') === 0) {
        track('frsn_outbound_click', { link_url: abs.href, link_domain: abs.host, link_text: text(link) });
        return;
      }
      // Social (footer/header)
      if (/instagram|tiktok|facebook|whatsapp|youtube|pinterest|twitter|x\.com/i.test(href)) {
        track('frsn_social_click', { link_url: href, link_text: text(link) });
        return;
      }
      // Produktkarte
      if (href.indexOf('/products/') !== -1) {
        var card = link.closest('[class*="prod-card"], [class*="product-card"], li, article');
        track('frsn_product_card_click', {
          product_handle: handleFromUrl(href, 'products'),
          link_text: text(link),
          list_name: card ? text(card.closest('section')) : ''
        });
        return;
      }
      // Kollektion
      if (href.indexOf('/collections/') !== -1) {
        track('frsn_collection_click', { collection_handle: handleFromUrl(href, 'collections'), link_text: text(link) });
        return;
      }
      // Navigation (Header/Footer)
      var navScope = link.closest('#headerGroup, #mainHeader, header, #footerGroup, footer, nav');
      if (navScope) {
        var section = /foot/i.test(navScope.id || navScope.tagName) ? 'footer' : 'header';
        track('frsn_nav_click', { link_text: text(link), link_url: href, nav_section: section });
        return;
      }
    }

    // Drawer / Dialog / Quickview Trigger (Theme nutzt data-open)
    var opener = e.target.closest('[data-open]');
    if (opener) {
      var target = (opener.getAttribute('data-open') || '').toLowerCase();
      var map = { cart: 'frsn_cart_open', menu: 'frsn_menu_open', search: 'frsn_search_open', quick: 'frsn_quickview_open' };
      var evt = 'frsn_drawer_open';
      for (var key in map) { if (Object.prototype.hasOwnProperty.call(map, key) && target.indexOf(key) !== -1) { evt = map[key]; break; } }
      track(evt, { target: target, label: text(opener) });
      return;
    }

    // Add-to-Cart-Intent (Klick; die Conversion selbst trackt das App-Pixel)
    var atc = e.target.closest('[name="add"], [data-add-to-cart], button[type="submit"]');
    if (atc && atc.closest('form[action*="/cart/add"]')) {
      track('frsn_atc_click', { label: text(atc), product_handle: handleFromUrl(window.location.pathname, 'products') });
      return;
    }

    // Generische CTA-Buttons
    var btn = e.target.closest('button, .button, [role="button"]');
    if (btn) {
      var label = text(btn);
      if (label) { track('frsn_cta_click', { label: label, location: btn.closest('section') ? text(btn.closest('section')).slice(0, 60) : '' }); }
    }
  }, true);

  // ---- Formulare: Suche + Newsletter ------------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) { return; }
    var action = form.getAttribute('action') || '';

    if (action.indexOf('/search') !== -1) {
      var q = form.querySelector('[name="q"]');
      track('frsn_search_submit', { search_term: q ? (q.value || '').slice(0, 100) : '' });
      return;
    }
    if (/contact|customer/.test(form.getAttribute('id') || '') || form.querySelector('input[type="email"]')) {
      var isNewsletter = /newsletter|klaviyo/i.test(form.className + ' ' + (form.getAttribute('id') || ''));
      track(isNewsletter ? 'frsn_newsletter_submit' : 'frsn_form_submit', { form_id: form.getAttribute('id') || '' });
    }
  }, true);

  // ---- Varianten- / Mengen-Änderungen -----------------------------------
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.name) { return; }
    if (el.name.indexOf('options') === 0 || el.closest('variant-selects, pdp-variant-picker, [class*="variant"]')) {
      track('frsn_variant_select', {
        option_name: el.getAttribute('data-option-name') || el.name,
        option_value: el.value,
        product_handle: handleFromUrl(window.location.pathname, 'products')
      });
    } else if (el.name === 'quantity' || el.getAttribute('type') === 'number') {
      track('frsn_quantity_change', { value: el.value });
    }
    // Collection-Filter/Sortierung
    if (el.closest('form[class*="facet"], #FacetFiltersForm, [class*="facets"]')) {
      track('frsn_filter_apply', { filter_name: el.name, filter_value: el.value });
    }
    if (el.name === 'sort_by') {
      track('frsn_sort_change', { value: el.value });
    }
  }, true);

  // ---- Accordions (PDP-Beschreibung, FAQ) -------------------------------
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.tagName === 'DETAILS' && d.open) {
      track('frsn_accordion_open', { label: text(d.querySelector('summary')) });
    }
  }, true);

  // ---- Video (play / complete) ------------------------------------------
  document.addEventListener('play', function (e) {
    if (e.target && e.target.tagName === 'VIDEO') {
      track('frsn_video_play', { src: (e.target.currentSrc || '').slice(0, 200) });
    }
  }, true);
  document.addEventListener('ended', function (e) {
    if (e.target && e.target.tagName === 'VIDEO') { track('frsn_video_complete', {}); }
  }, true);

  // ---- Scroll-Tiefe ------------------------------------------------------
  var marks = [25, 50, 75, 90];
  var hit = {};
  function onScroll() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) { return; }
    var pct = Math.round((window.scrollY / scrollable) * 100);
    for (var i = 0; i < marks.length; i++) {
      var m = marks[i];
      if (pct >= m && !hit[m]) { hit[m] = true; track('frsn_scroll_depth', { percent: m }); }
    }
  }
  window.addEventListener('scroll', function () {
    window.requestAnimationFrame(onScroll);
  }, { passive: true });

  // ---- Verweildauer (beim Verlassen/Verbergen) --------------------------
  var start = Date.now();
  var sent = false;
  function sendEngagement() {
    if (sent) { return; }
    sent = true;
    track('frsn_engagement_time', { seconds: Math.round((Date.now() - start) / 1000) });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { sendEngagement(); }
  });
  window.addEventListener('pagehide', sendEngagement);
})();
